import { Box } from '@wix/design-system';
import { WIX_STUDIO_HEADER_HEIGHT } from '@wix/core-domain-search';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React, { useEffect, useRef, useState } from 'react';
import { BackToTopButton } from '../../Components/BackToTopButton';
import { FAQs } from '../../Components/FAQs';
import { SiteGateHeader } from '../../Components/Headers';
import { AccountGateHeader } from '../../Components/Headers/AccountGateHeader';
import { MoreTools } from '../../Components/MoreTools';
import { PreSuggestions } from '../../Components/PreSuggestions';
import { SocialProofCard } from '../../Components/SocialProofCard';
import { TldPromotionsWithPrice } from '../../Components/TldPromotionsWithPrice';
import { LoggedInMobileVoucherBanner } from '../../Components/VoucherBanner/LoggedInMobileVoucherBanner';
import { useDomainSearchGateBi } from '../../hooks/useDomainSearchGateBi';
import { useQuerySubmit } from '../../hooks/useQuerySubmit';
import { useViewTransition } from '../../hooks/useViewTransition';
import s from '../SearchGateHome/searchGateHome.scss';
import local from './LoggedInMobileGate.scss';
import transition from '../viewTransitions.css';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { ViewMode } from '../../types';
const LoggedInMobileGateContent = () => {
  var _getPremiumEssentials;
  const _useViewTransition = useViewTransition(),
    navigateTo = _useViewTransition.navigateTo;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.SDK.hooks.useUrlRecovery(),
    getUrlState = _DomainSearchSuiteMod.getUrlState;
  const siteName = (_getPremiumEssentials = getPremiumEssentialsSafe()) == null ? void 0 : _getPremiumEssentials.siteName;
  const sentinelRef = useRef(null);
  const _useState = useState(false),
    isPinned = _useState[0],
    setIsPinned = _useState[1];
  const barWrapperRef = useRef(null);
  const _useState2 = useState(0),
    barHeight = _useState2[0],
    setBarHeight = _useState2[1];
  useEffect(() => {
    const el = sentinelRef.current;
    if (!el || typeof IntersectionObserver === 'undefined') {
      return;
    }
    const observer = new IntersectionObserver(_ref => {
      var _entry$rootBounds;
      let entry = _ref[0];
      if (!entry) {
        return;
      }
      const rootTop = ((_entry$rootBounds = entry.rootBounds) == null ? void 0 : _entry$rootBounds.top) ?? 0;
      setIsPinned(!entry.isIntersecting && entry.boundingClientRect.top <= rootTop);
    }, {
      rootMargin: `-${WIX_STUDIO_HEADER_HEIGHT} 0px 0px 0px`,
      threshold: 0
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const el = barWrapperRef.current;
    if (!el || isPinned) {
      return;
    }
    setBarHeight(el.offsetHeight);
    if (typeof ResizeObserver === 'undefined') {
      return;
    }
    const observer = new ResizeObserver(() => setBarHeight(el.offsetHeight));
    observer.observe(el);
    return () => observer.disconnect();
  }, [isPinned]);
  useDomainSearchGateBi({
    viewMode: ViewMode.GATE,
    reportGatePageLoadEvents: false,
    useReferralAdditionalInfoAsSearchOrigin: true
  });
  useQuerySubmit({});
  return /*#__PURE__*/React.createElement(Box, {
    padding: "16px",
    direction: "vertical",
    gap: "SP4",
    align: "center",
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: "white",
    scrollBehavior: "smooth",
    height: "100%",
    display: "grid",
    gridTemplateRows: "max-content max-content 1fr",
    gridTemplateAreas: " \"banner\" \"header\" \"content\" "
  }, /*#__PURE__*/React.createElement("section", {
    className: s.voucherBannerContainer
  }, /*#__PURE__*/React.createElement(LoggedInMobileVoucherBanner, null)), /*#__PURE__*/React.createElement("header", {
    className: s.header
  }, /*#__PURE__*/React.createElement(Box, {
    align: "center",
    borderRadius: "12px",
    width: "100%",
    direction: "vertical",
    gap: "24px",
    boxSizing: "border-box",
    padding: "38px 16px",
    backgroundColor: "#E2D8FF",
    overflow: "hidden",
    zIndex: 1
  }, siteName ? /*#__PURE__*/React.createElement(SiteGateHeader, {
    gap: "18px",
    className: transition.header
  }) : /*#__PURE__*/React.createElement(AccountGateHeader, {
    gap: "18px",
    className: transition.header
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%'
    },
    className: transition.searchBar
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: isPinned ? barHeight : 0
    }
  }), /*#__PURE__*/React.createElement("div", {
    ref: barWrapperRef,
    className: isPinned ? local.pinnedSearchBar : undefined,
    style: isPinned ? {
      top: WIX_STUDIO_HEADER_HEIGHT
    } : undefined
  }, /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.DomainSearchBar, {
    useModalToolbar: true,
    compact: isPinned,
    autoFocus: false,
    onFiltersChange: (key, value) => {
      if (key === 'tlds') {
        DomainSearchSuiteModule.internals.bi.onSelectTld == null || DomainSearchSuiteModule.internals.bi.onSelectTld({
          tld: JSON.stringify(value)
        });
      } else {
        DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
          ctaClick: key,
          value: JSON.stringify(value)
        });
      }
    },
    onSubmit: filters => {
      const searchParams = getUrlState(filters);
      navigateTo(`/results?${searchParams}`);
    }
  })), /*#__PURE__*/React.createElement("div", {
    ref: sentinelRef,
    style: {
      height: 0
    }
  })))), /*#__PURE__*/React.createElement("main", {
    className: transition.content,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4",
    display: "grid",
    className: s.content,
    gridTemplateRows: "repeat(max-content, auto)"
  }, siteName && /*#__PURE__*/React.createElement(PreSuggestions, null), /*#__PURE__*/React.createElement(SocialProofCard, null), /*#__PURE__*/React.createElement(TldPromotionsWithPrice, {
    variant: "list"
  }), /*#__PURE__*/React.createElement(MoreTools, null), /*#__PURE__*/React.createElement(FAQs, {
    onToggle: index => {
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'asked_questions',
        value: JSON.stringify(index)
      });
    }
  }))), /*#__PURE__*/React.createElement(BackToTopButton, null));
};
export const LoggedInMobileGate = _ref2 => {
  let handlers = _ref2.handlers;
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      enabledActions: [],
      handlers,
      siteInfo: {
        externalViewer: false
      }
    }
  }, /*#__PURE__*/React.createElement(LoggedInMobileGateContent, null));
};
//# sourceMappingURL=LoggedInMobileGate.js.map